// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"institution"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3 7L12 2L21 7V8H3V7Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 22H3M6 12V18M12 12V18M18 12V18M3 7V8H21V7L12 2L3 7Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const InstitutionIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'institution',
    ref,
    icon: element,
  },
));

InstitutionIcon.displayName = 'InstitutionIcon';

export default InstitutionIcon;
